/* eslint-disable */
export default {
  region: 'Region',
  calling: 'Calling',
  logout: 'Log out',
  version: 'Version',
  settings: 'Settings',
  selectToDialSMS: 'Select to Dial/SMS',
  selectToDial: 'Select to Dial',
  selectToSMS: 'Select to SMS',
  clickToDial: 'Click to dial',
  autoCreateLog: 'Auto-create call log',
  autoCreateSMSLog: 'Auto-create SMS log',
  autoLogCalls: 'Auto-log calls',
  autoLogNotes: 'Auto-log notes',
  autoLogSMS: 'Auto-log SMS',
  clickToSMS: 'Click to SMS',
  logSMSContent: 'Log SMS content',
  clickToDialSMS: 'Click to dial/SMS',
  logExtensionCall: 'Log extension calls',
  audio: 'Audio',
  language: 'Language',
  feedback: 'Feedback',
  userGuide: 'What’s New',
  quickAccess: 'Quick access setting',
  report: 'Analytics report',
  shareIdea: 'Share idea',
  openEntityFrom: 'Salesforce object behaviour',
  ctiPanelSize: 'CTI panel size',
  openInNewTab: 'Open in new tab',
  openInCurrentTab: 'Open in current tab',
  reportIssue: 'Report issue',
  contactSupport: 'Contact support',
  selectToDialHint:
    'For a better experience, select a phone number to dial with RingCentral on the large-quantity phone number page.',
} as const;

// @key: @#@"region"@#@ @source: @#@"Region"@#@
// @key: @#@"calling"@#@ @source: @#@"Calling"@#@
// @key: @#@"logout"@#@ @source: @#@"Logout"@#@
// @key: @#@"version"@#@ @source: @#@"Version"@#@
// @key: @#@"settings"@#@ @source: @#@"Settings"@#@
// @key: @#@"selectToDialSMS"@#@ @source: @#@"Select to Dial/SMS"@#@
// @key: @#@"selectToDial"@#@ @source: @#@"Select to Dial"@#@
// @key: @#@"selectToSMS"@#@ @source: @#@"Select to SMS"@#@
// @key: @#@"clickToDial"@#@ @source: @#@"Click to Dial"@#@
// @key: @#@"autoCreateLog"@#@ @source: @#@"Auto-create Call Log"@#@
// @key: @#@"autoCreateSMSLog"@#@ @source: @#@"Auto-create SMS Log"@#@
// @key: @#@"autoLogCalls"@#@ @source: @#@"Auto log calls"@#@
// @key: @#@"autoLogNotes"@#@ @source: @#@"Auto log notes"@#@
// @key: @#@"autoLogSMS"@#@ @source: @#@"Auto log SMS"@#@
// @key: @#@"clickToSMS"@#@ @source: @#@"Click to SMS"@#@
// @key: @#@"logSMSContent"@#@ @source: @#@"Log SMS content"@#@
// @key: @#@"clickToDialSMS"@#@ @source: @#@"Click to Dial/SMS"@#@
// @key: @#@"logExtensionCall"@#@ @source: @#@"Log extension calls"@#@
// @key: @#@"audio"@#@ @source: @#@"Audio"@#@
// @key: @#@"language"@#@ @source: @#@"Language"@#@
// @key: @#@"feedback"@#@ @source: @#@"Feedback"@#@
// @key: @#@"userGuide"@#@ @source: @#@"What's New"@#@
// @key: @#@"quickAccess"@#@ @source: @#@"Quick Access Setting"@#@
// @key: @#@"report"@#@ @source: @#@"Analytics Report"@#@
// @key: @#@"shareIdea"@#@ @source: @#@"Share idea"@#@
// @key: @#@"openEntityFrom"@#@ @source: @#@"Salesforce object behavior"@#@
// @key: @#@"ctiPanelSize"@#@ @source: @#@"CTI panel size"@#@
// @key: @#@"openInNewTab"@#@ @source: @#@"Open in new tab"@#@
// @key: @#@"openInCurrentTab"@#@ @source: @#@"Open in current tab"@#@
// @key: @#@"reportIssue"@#@ @source: @#@"Report issue"@#@
// @key: @#@"contactSupport"@#@ @source: @#@"Contact support"@#@
// @key: @#@"selectToDialHint"@#@ @source: @#@"For your better experience, select phone number to dial with RingCentral in large quantity phone number page."@#@
